module.exports = __webpack_public_path__ + "img/2-l.9cf21a39.png";